module.exports = __webpack_public_path__ + "img/finance-grey.ebc464a.svg";